module.exports = __webpack_public_path__ + "static/img/2.2.dfc1e38.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/eng/2.2.png
// module id = 6RLG
// module chunks = 0